import React from 'react'
import { get, isEmpty } from 'lodash'
import Slider from 'react-slick'
import SliderSettings from '~/tools/slickSliderSettings'
import Link from '~/components/Link'
import NetflixTrayItem from './netflix-tray-item'
import NewsTrayItem from "./NewsVideoTray/news-tray-item"
import TrayItem from './trayItem'
import BlockTitle from '~/components/BlockTitle'
import pageStore from '~/redux/page/store'
import { trackEvent } from '~/tools/analytics/googleAnalytics'

import "./style.scss";

class Tray extends React.Component {
	constructor(props) {
		super(props);
		const page = pageStore.getState();
		const categoryMap = page.data.categoryMap;
		const filter = get(props, "data.filters.categories[0]");
		const category =
			get(props, "data.categoryUrl") ||
			(filter && categoryMap && categoryMap[filter]);

		this.state = {
			filter: get(props, "data.filter", filter),
			items: get(props, "data.contentData", []),
			title: get(props, "data.title", "") || props.title,
			seeAllPermalink: get(props, "data.settings.seeAllPermalink") || category,
			seeAllCard: get(props, "data.settings.seeAllCard"),
			seeAllChevron: get(this.props, "data.settings.seeAll")
		};

		this.goToTrayItem = this.goToTrayItem.bind(this);
	}

	componentDidMount() {
		this.setState({
			innerWidth: window.innerWidth
		});
		const nextButton = this.container.querySelector(".slick-next");
		nextButton !== null &&
			nextButton.addEventListener("click", e => {
				!this.state.clickNext &&
					this.setState({
						clickNext: true
					});
			});
	}

	componentWillReceiveProps(nextProps) {
		if (!isEmpty(nextProps.title)) {
			this.setState({
				title: nextProps.title
			});
		}
		if (nextProps.dataToShow) {
			if (nextProps.dataToShow.length > 0) {
				this.setState({ items: nextProps.dataToShow });
			} else {
				this.setState({ items: [] });
			}
		} else {
			this.setState({
				items: get(nextProps, "data.contentData", [])
			});
		}
	}

	goToTrayItem(idx) {
		this.slider.slickGoTo(idx);
	}

	getCurrentTrayItem(settings, item, sliderSettings, i) {
		let currentTrayItem = (
			<TrayItem
				{...settings}
				item={item}
				maxWidth={
					this.state.innerWidth < 600
						? sliderSettings.mobileMaxWidth
						: sliderSettings.maxWidth
				}
				isEpisode={get(this.props, "data.isEpisode")}
				isBundle={get(this.props, "data.isBundle")}
				bundlePurchased={get(this.props, "data.bundlePurchased")}
				noEpisodeNumber={this.props.data.noEpisodeNumber}
				index={i}
				season={this.props.season}
				sharing={this.props.data.sharing}
				noBoxshadow={this.props.data.noBoxshadow}
				openEpisodeOverlay={this.props.openEpisodeOverlay}
				purchaseBundleItem={this.props.purchaseBundleItem}
				onFocus={this.goToTrayItem}
				clickNext={this.state.clickNext}
				trayTitle={
					this.props.trayTitle ? this.props.trayTitle : this.state.title
				}
				lazyLoad={
					this.props.lazyLoad === undefined ? true : this.props.lazyLoad
				}
				refItems={this.state.items}
			/>
		);
		if (this.props.netflix) {
			currentTrayItem = (
				<NetflixTrayItem
					{...settings}
					noBadgeImage={this.props.noBadgeImage}
					item={item}
					maxWidth={
						this.state.innerWidth < 600
							? sliderSettings.mobileMaxWidth
							: sliderSettings.maxWidth
					}
					isEpisode={get(this.props, "data.isEpisode")}
					noEpisodeNumber={this.props.data.noEpisodeNumber}
					index={i}
					season={this.props.season}
					sharing={this.props.data.sharing}
					noBoxshadow={this.props.data.noBoxshadow}
					openEpisodeOverlay={this.props.openEpisodeOverlay}
					onFocus={this.goToTrayItem}
					clickNext={this.state.clickNext}
					lazyLoad={
						this.props.lazyLoad === undefined ? true : this.props.lazyLoad
					}
					refItems={this.state.items}
					slidesToScroll={ sliderSettings.slidesToScroll }
					hideCategories={this.props.hideCategories}
					showCount={this.props.showCount}
					showProgressBar={this.props.showProgressBar || false}
					showDetailsBottom={this.props.showDetailsBottom || false}
					showPlayIcon={this.props.showPlayIcon || false}
					onlyPrimaryCategory={this.props.onlyPrimaryCategory}
				/>
			);
		}
		if (this.props.newsTray) {
			currentTrayItem = (
				<NewsTrayItem
					{...settings}
					item={item}
					maxWidth={
						this.state.innerWidth < 600
							? sliderSettings.mobileMaxWidth
							: sliderSettings.maxWidth
					}
					isEpisode={get(this.props, "data.isEpisode")}
					noEpisodeNumber={this.props.data.noEpisodeNumber}
					index={i}
					season={this.props.season}
					sharing={this.props.data.sharing}
					noBoxshadow={this.props.data.noBoxshadow}
					openEpisodeOverlay={this.props.openEpisodeOverlay}
					onFocus={this.goToTrayItem}
					clickNext={this.state.clickNext}
					trayTitle={
						this.props.trayTitle ? this.props.trayTitle : this.state.title
					}
					lazyLoad={
						this.props.lazyLoad === undefined ? true : this.props.lazyLoad
					}
					newsTrayId={this.props.newsTrayId}
					refItems={this.state.items}
				/>
			);
		}

		return currentTrayItem;
	}

	render() {
		const settings = this.props.layout.settings;
		const columns = settings.columns || {
			desktop: 7,
			mobile: 3,
			tablet: 6,
			ott: 7
		};
		let hasMultipleItems = get(this.state, "items.length", 0) > columns.desktop;
		if (window.innerWidth < 768) {
			hasMultipleItems = get(this.state, "items.length", 0) > columns.mobile;
		}
		const sliderSettings = new SliderSettings(columns);
		const isPLL = window.settings.internalName.includes("plleague");
		const isHidden = get(this.props, "layout.settings.isHidden");
		if(this.props.trayTitle && this.props.trayTitle==="recommdationTray"){
			trackEvent('recommendation-tray', 'isRecommendation', "true")
		}

    return (
      <div
        ref={el => this.container = el}
        className={`video-tray ${settings.infoHover ? 'infoHover' : ''} ${this.props.override ? 'override-tray' : ''} ${settings.thumbnailType ? settings.thumbnailType : ''} ${isHidden ? 'hide' : ''} ${isPLL ? 'pll-wrapper' : ''}`}
      >

      <div className={this.props.neouTrayTitle ? "tray-wrapper" : "tray-wrapper-common"}> {/* Only for NEOU video tray, neouTrayTitle is true */}
        { get(this.props, 'data.noBlockTitle')
          ? <div className="tray-header">{this.state.title}</div>
          : this.state.title && <BlockTitle>{this.state.title}{this.props.showCount && this.state.items && <span>{` (${this.state.items.length})`}</span>}</BlockTitle>
        }
        { this.state.seeAllChevron && this.state.seeAllPermalink
          ? <Link href={this.state.seeAllPermalink} className="tray-detail"><i className="ion-chevron-right"/></Link>
          : null
        }
        </div>
        <div className={`items ${this.props.override ? 'override' : ''}`}>
          { this.state.items && this.state.items.length > 0 &&
            <Slider
              ref={ el => this.slider = el }
              dots={false}
              infinite={settings.loop}
              arrows={hasMultipleItems}
              slidesToShow={ sliderSettings.slidesToShow }
              slidesToScroll={ sliderSettings.slidesToScroll }
              responsive={ sliderSettings.responsiveBreakpoints }
              lazyLoad={this.props.lazyLoad === undefined ? true: this.props.lazyLoad}
              draggable={this.props.draggable}
              {...this.props.settings}>
				{this.state.items.map((item, i) => (
					<div key={i}>
						{this.getCurrentTrayItem(settings, item, sliderSettings, i)}
					</div>
				))}
				{this.state.seeAllCard && this.state.seeAllPermalink && (
					<a className="tray-last-item" href={this.state.seeAllPermalink}>
						<div className="image-and-details">
							{settings.thumbnailType !== "landscape" && (
								<div className="image">
									<img
										src={get(window.settings, "images.desktopLogo")}
										alt="logo"
									/>
								</div>
							)}
							<div className="details">
								<div className="see-all">See All</div>
								<div className="category-name">{this.state.title}</div>
							</div>
						</div>
					</a>
				)}
			</Slider>}
		</div>
	</div>);
	}
}

export default Tray;
